import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_AU6c9AvKnUQ5GdvaRbAjC2yQ4fELnFt2h5yo5bcRDorp';
const POSTHOG_HOST = 'https://us.i.posthog.com';

export function initPostHog() {
  if (typeof window !== 'undefined') {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      capture_pageview: false,       // We handle pageviews manually with React Router
      capture_pageleave: true,
      autocapture: true,
    });
  }
}

export default posthog;
